/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

import {SiteConfigContext} from '../context/SiteConfigContext';

const Layout = ({pageContext, children}) => {
    let faviconSite = pageContext.basePath // if basePath exists
        ? pageContext.theme // 'vrbo'
        : pageContext.sitename; // 'homeaway_de' 'stayz' etc
    const faviconHref = `https://csvcus.homeaway.com/rsrcs/cdn-logos/3.2.0/bce/moniker/${faviconSite}/favicon.ico`;
    return (
        <SiteConfigContext.Provider value={{...pageContext}}>
            <Header />
            <Helmet>
                <link rel="shortcut icon" type="image/png" href={faviconHref} />
            </Helmet>
            {children}
            <Footer />
        </SiteConfigContext.Provider>
    );
};

Layout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default Layout;
